import { type IDrawService, type IGetDrawForecastUseCase, NotFoundError } from '../../../domain/entry.js';

/**
 * Use case for retrieving the forecast of a specific draw.
 *
 * @param drawService - The service to interact with draw.
 * @returns Draw forecast data
 */
export function getDrawForecastUseCase(drawService: IDrawService): IGetDrawForecastUseCase {
  return {
    execute: async ({ product, drawNumber }): ReturnType<IGetDrawForecastUseCase['execute']> => {
      const drawForecast = await drawService.getDrawForecastAsync(product, { drawNumber });

      if (!drawForecast) {
        throw new NotFoundError(`Draw forecast for ${product} with draw number ${drawNumber} not found`);
      }

      return drawForecast;
    },
  };
}
